export default __webpack_public_path__ + "static/MediaContentFiveFancybox-b0d846e86c7e4e9e5fe7974b6fd2525e.webp";